const CGU_UPDATE_ACKNOWLEDGEMENT_API = '/api/webpref/cgu-version-acceptance-acknowledgement';
const CGU_VERSION_TO_BE_ACCEPTED = '2019-12-01';

Hop.defineModule('legal-update-acceptance', (root) => {
    const domAcceptCta = root.querySelector('#legalAcceptCta');

    function getCguAcceptanceAcknowledgement() {
        return Hop.get(CGU_UPDATE_ACKNOWLEDGEMENT_API).then((data) => data.text());
    }

    function shouldModalBeDisplayed() {
        const isPageLegal = document.querySelector('#legal-page');
        if (!isPageLegal) {
            return getCguAcceptanceAcknowledgement().then((value) => value !== CGU_VERSION_TO_BE_ACCEPTED);
        }

        return Promise.resolve(false);
    }

    function displayModalIfNeeded(hasToBeDisplayed) {
        if (!hasToBeDisplayed) {
            return;
        }

        $(root).modal('show');
    }

    function acceptCguUpdate() {
        $.post(CGU_UPDATE_ACKNOWLEDGEMENT_API, {
            value: CGU_VERSION_TO_BE_ACCEPTED,
        });
    }

    function setupListeners() {
        domAcceptCta.addEventListener('click', acceptCguUpdate);
    }

    setupListeners();
    shouldModalBeDisplayed().then(displayModalIfNeeded);

    return function destroy() {
        domAcceptCta.removeEventListener('click', acceptCguUpdate);
    };
});
